module.exports = __webpack_public_path__ + "img/color-ladybird.e32d6271.svg";